module.exports = __webpack_public_path__ + "img/AT0000002576211.9274f1b8.png";